import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Book Types',
  basePath: '/book-types',
  reorderable: true,
  columns: [
    { key: 'orderby', label: 'Order' },
    { key: 'type', label: 'Book Type' },
  ],
  fields: [
    { key: 'type', label: 'Book Type', type: 'text', required: true },
    { key: 'icon', label: 'Icon', type: 'file', accept: 'image/*', photo: true },
  ],
});
